import getConfig from 'next/config';
import { Guid } from '@devex/devex-shared';

const { publicRuntimeConfig } = getConfig();
const { SHOPIFY_API_KEY, AI_WEB_INSTRUMENTATION_KEY } = publicRuntimeConfig;

export class ConfigService {
	public static readonly $name = 'config-service';

	private readonly shopifyApiKey = SHOPIFY_API_KEY || '';

	private readonly appInsightsWebInstrumentationKey = AI_WEB_INSTRUMENTATION_KEY;

	public getShopifyDetails(): { apiKey: string, isDevMode: boolean } {
		const apiKey = this.shopifyApiKey;

		return {
			apiKey,
			isDevMode: false,
		};
	}

	public getAppInsightsDetails(): { apiKey: string, clientId: string } {
		const appKey = this.appInsightsWebInstrumentationKey;

		let clientId = localStorage.getItem('clientId');
		if (!clientId) {
			clientId = Guid.next().toString();

			localStorage.setItem('clientId', clientId);
		}

		return {
			apiKey: appKey,
			clientId,
		};
	}
}
